import React from 'react';
import {Link} from "react-router-dom";
import '../styles/_404.css';
import '../styles/Global.css';
import '../styles/TutorialArchive.css'
import gh from "../Assets/Game View/Gameplay-Home.png";

const previewImages = {
    themePreview: require("../Assets/Tutorials/Tutorial Preview Images/ThemePreview.png"),
    decorateMapPreview: require("../Assets/Tutorials/Tutorial Preview Images/StreamEditor.png")
}

export default function tutorialArchive() {
    return (
        <div className="content">

                <div className="about-frame">

                    <div id="about">
                        <p>TUTORIAL ARCHIVE.</p>
                    </div>
                    <div className="everything-container">
                <span className="normal-text">
                    There are certain features in Poly Beats that would usually require you to be pretty smart to pull off.
                <br/><br/>
                    Luckily, I'm not, and I don't expect you to be, either. So here's some tutorials on how to do certain things in our game.

                </span>

                        <div className="theme-buttons-container">
                            <Link to="/tutorial-archive/themes" className="fof-image-button">
                                <img src={previewImages.themePreview} alt="How to make a theme"/>
                                <span className="image-caption">HOW TO MAKE A THEME</span>
                            </Link>

                            <Link to="/tutorial-archive/stream-editor" className="fof-image-button">
                                <img src={previewImages.decorateMapPreview} alt="How to decorate a map"/>
                                <span className="image-caption">HOW TO DECORATE A MAP</span>
                            </Link>
                        </div>
                    </div>
                </div>
        </div>
    );
}